import { render, staticRenderFns } from "./EssentialsCategoryBanner.vue?vue&type=template&id=f4163a22&"
import script from "./EssentialsCategoryBanner.vue?vue&type=script&lang=js&"
export * from "./EssentialsCategoryBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports